import {
  SET_PROMOTION,
  SET_PROMOTION_HELPERS
} from 'src/store/mutation-types'
export default {
  [SET_PROMOTION] (state, promotion) {
    state.promotion = promotion
  },
  [SET_PROMOTION_HELPERS] (state, helpers) {
    state.promotionHelpers = helpers
  }
}



// WEBPACK FOOTER //
// ./src/components/promotion/store/mutations.js